<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      title="隐私政策"
    ></van-nav-bar>
    <h2 class="ta-c">隐私政策</h2>
    <div class="content">
      <div>
        本政策仅适用于天安(贵州省)互联网金融资产交易中心股份有限公司及其关联公司(以下或称"我们"或"天安金交中心")提供的产品和服务及其延伸功能(以下简称"天安金交中心服务")，包括天安金交中心APP。如我们提供的某款产品有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品的隐私政策将优先适用；该款产品隐私政策和用户服务协议未涵盖的内容，以本政策内容为准。
      </div>
      <div>
        我们非常重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的其明服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
      </div>
      <div>
        您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
      </div>
      <h3>我们可能收集的信息</h3>
      <div>
        我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
      </div>
      <h3>您提供的信息</h3>
      <div>
        您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等
      </div>
      <div>
        您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息
      </div>
      <h3>我们获取的您的信息</h3>
      <div>您使用服务时我们可能收集如下信息：</div>
      <div>
        日志信息，指您使用我们的服务时，系统可能通过cookies、web
        beacon或其他方式自动采集的技术信息，包括：设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
      </div>
      <div>
        在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
      </div>
      <h3>我们可能如何使用信息</h3>
      <div>我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</div>
      <p><b>向您提供服务</b></p>
      <p>
        在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性
      </p>
      <p>
        帮助我们设计新服务，改善我们现有服务；使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、
        位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应
      </p>
      <p>
        为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
      </p>
      <p><b>您如何访问和控制自己的个人信息</b></p>
      <p>
        我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
      </p>
      <h3>我们可能分享的信息</h3>
      <div>
        除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息。
      </div>
      <div>
        我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理分享，用作下列用途：
      </div>
      <p><b>向您提供我们的服务</b></p>
      <p>实现“我们可能如何使用信息”部分所述目的；</p>
      <p>履行我们在本《隐私政策》中的义务和行使我们的权利；</p>
      <p>理解、维护和改善我们的服务。</p>
      <div>
        如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
      </div>
      <div>
        随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
      </div>
      <div>
        我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：
      </div>
      <p>遵守适用的法律法规</p>
      <p>遵守法院命令或其他法律程序的规定</p>
      <p>遵守相关政府机关的要求</p>
      <div>
        为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途
      </div>
      <h3>信息安全</h3>
      <div>
        我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。
      </div>
      <div>
        我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
      </div>
      <div>您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。</div>
      <h3>我们可能如何收集信息</h3>
      <div>
        我们或我们的第三方合作伙伴，可能通过cookies和web
        beacon收集和使用您的信息，并将该等信息储存为日志信息。
      </div>
      <div>
        我们使用自己的cookies和web
        beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：
      </div>
      <div>
        记住您的身份。例如：cookies和web
        beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；
      </div>
      <div>
        分析您使用我们服务的情况。例如，我们可利用cookies和web
        beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎;
      </div>
      <h3>我们可能向您发送的邮件和信息</h3>
      <div><b>邮件和信息推送</b></div>
      <div>
        您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。
      </div>
      <div><b>与服务有关的公告</b></div>
      <div>
        我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。
      </div>
      <h3>隐私政策的适用范围</h3>
      <div>
        除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策
      </div>
      <div>
        除本《隐私政策》另有规定外，本《隐私条款》所用词语将与《其明服务协议》所定义的词语具有相同的涵义。
      </div>
      <div>请您注意，本《隐私政策》不适用于以下情况：</div>
      <p>通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；</p>
      <p>通过在我们服务中进行广告服务的其他公司或机构所收集的信息。</p>
      <h3>变更</h3>
      <div>
        我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant'
export default {
  name: 'privacy',
  components: {
    [NavBar.name]: NavBar,
  },
}
</script>

<style lang="less" scoped>
.page-container {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}
p {
  text-indent: 20px;
}
h3 {
  text-align: center;
}
.content > div > b:first-child {
  margin-right: 14px;
}
.van-nav-bar {
  background: #fff;

  .van-nav-bar__title {
    color: @dark;
  }
  .van-icon {
    color: @dark !important;
  }
}
</style>
